export const TERMS_AND_CONDITIONS_CONTENT = {
  es: ``,
  en: ``,
};
